import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Mail } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import AuraLogo from './AuraLogo';
import BetaSignupForm from './BetaSignupForm';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const [showBetaSignup, setShowBetaSignup] = useState(false);
  const year = new Date().getFullYear();

  return (
    <footer className="bg-[#10141d] text-white">
      <div className="mx-auto w-[calc(100%_-_48px)] max-w-[1200px] py-16">
        <div className="grid gap-14 border-b border-white/15 pb-16 md:grid-cols-[1.3fr_0.7fr_0.7fr]">
          <div className="max-w-md">
            <AuraLogo className="text-white" width={154} height={42} />
            <p className="mt-5 text-sm leading-7 text-white/58">{t('footer.description')}</p>
            <button
              onClick={() => setShowBetaSignup(true)}
              className="mt-7 inline-flex items-center gap-2 border-b border-[#c9a84c] pb-1 text-sm font-semibold text-[#e8d9a0]"
            >
              {t('footer.join_early_access')} <ArrowUpRight size={15} />
            </button>
          </div>

          <div>
            <p className="mb-5 text-[11px] font-bold uppercase tracking-[0.16em] text-white/40">
              {t('footer.explore')}
            </p>
            <nav className="grid gap-3 text-sm text-white/70">
              <Link to="/how-it-works" className="hover:text-white">{t('navigation.how_it_works')}</Link>
              <Link to="/features" className="hover:text-white">{t('navigation.features')}</Link>
              <Link to="/pricing" className="hover:text-white">{t('navigation.pricing')}</Link>
              <Link to="/about" className="hover:text-white">{t('navigation.about')}</Link>
            </nav>
          </div>

          <div>
            <p className="mb-5 text-[11px] font-bold uppercase tracking-[0.16em] text-white/40">
              {t('navigation.contact')}
            </p>
            <a
              href="mailto:info@auratrainer.app"
              className="inline-flex items-center gap-2 text-sm text-white/70 hover:text-white"
            >
              <Mail size={15} /> info@auratrainer.app
            </a>
            <nav className="mt-6 grid gap-3 text-sm text-white/70">
              <Link to="/support" className="hover:text-white">{t('footer.sections.product.support')}</Link>
              <Link to="/status" className="hover:text-white">{t('footer.system_status')}</Link>
            </nav>
          </div>
        </div>

        <div className="flex flex-col gap-5 pt-7 text-xs text-white/40 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} Aura. {t('footer.company_info.all_rights_reserved')}</p>
          <nav className="flex flex-wrap gap-5">
            <Link to="/privacy" className="hover:text-white">{t('footer.legal.privacy_short')}</Link>
            <Link to="/terms" className="hover:text-white">{t('footer.legal.terms_short')}</Link>
            <Link to="/cookie-policy" className="hover:text-white">{t('footer.legal.cookies_short')}</Link>
            <Link to="/ccpa-privacy" className="hover:text-white">CCPA</Link>
          </nav>
        </div>
      </div>

      <BetaSignupForm isOpen={showBetaSignup} onClose={() => setShowBetaSignup(false)} />
    </footer>
  );
};

export default Footer;
